export default "__VITE_ASSET__X1XpZ63s__"